import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=59cf82d9&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=59cf82d9&prod&lang=scss"
import style1 from "./Product.vue?vue&type=style&index=1&id=59cf82d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cf82d9",
  null
  
)

export default component.exports